import { WDS_V2_WIDGET_MAP } from "widgets/wds/constants";

/**
 * Successor widgets that supersede an earlier WDS widget when they are
 * registered (e.g. the EE-only TanStack v8 Anvil table replaces the v7 WDS
 * table). Keyed by the superseded WDS type.
 */
const WDS_SUCCESSOR_WIDGET_MAP: Record<string, string> = {
  WDS_TABLE_WIDGET: "WDS_ANVIL_TABLE_WIDGET",
};

/**
 * Resolves the WDS widget type to create for a suggested widget on an Anvil
 * canvas. Accepts both legacy types (map keys, e.g. TABLE_WIDGET_V2) and WDS
 * types (map values, e.g. WDS_TABLE_WIDGET), and prefers a registered
 * successor widget over the resolved type when one exists.
 *
 * Returns undefined when the suggested type has no Anvil counterpart.
 */
export function resolveSuggestedWdsType(
  suggestedType: string,
  isTypeRegistered: (type: string) => boolean,
): string | undefined {
  const wdsEntry = Object.entries(WDS_V2_WIDGET_MAP).find(
    ([legacyType, wdsType]) =>
      legacyType === suggestedType || wdsType === suggestedType,
  );

  if (!wdsEntry) {
    return undefined;
  }

  const [, wdsType] = wdsEntry;
  const successorType = WDS_SUCCESSOR_WIDGET_MAP[wdsType];

  if (successorType && isTypeRegistered(successorType)) {
    return successorType;
  }

  return wdsType;
}
